import { render, staticRenderFns } from "./ConsultantDetails.vue?vue&type=template&id=670c7e7e"
import script from "./ConsultantDetails.vue?vue&type=script&lang=js"
export * from "./ConsultantDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsultantDetails.vue?vue&type=style&index=0&id=670c7e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports